import { put } from 'redux-saga/effects';

import AccountActions from '../Actions/Account';

export default {
  *startup() {
    yield put(AccountActions.checkStatus());
  }
};
